import { mainUrl, client } from '../app-constants';

export function getPianoTechCompanyList() {
    const url = mainUrl + 'pt.company/listPianoTechCompany'

    return client.get(url);
}

export function findPianoTechCompany(companyId) {
    const url = mainUrl + 'pt.company/findPianoTechCompany?companyId=' + companyId;

    return client.get(url);
}

export function savePianoTechCompany(pianoTechCompany) {
    const url = mainUrl + 'pt.company/savePianoTechCompany';

    return client.post(url,pianoTechCompany);
}

